import { createSlice } from "@reduxjs/toolkit";
import { extendSliceWithAssignees } from "slices/assignees/utils";

export const INITIAL_STATE = {
  isLoading: false,
  isBackgroundFilesLoading: false,
  data: null,
  documents: [],
  docTypes: [],
  oppType: null,
};

const summarySlice = createSlice({
  name: "summary",
  initialState: INITIAL_STATE,
  reducers: {
    setIsLoading(state, { payload: isLoading = false }) {
      state.isLoading = isLoading;
    },
    setOpportunity(state, { payload = null }) {
      state.data = payload;
    },
    untrackOpportunity(state) {
      state.data.tracked = false;
    },
    ...extendSliceWithAssignees({
      rootPath: "data",
      actionName: "setOpportunityAssignees",
    }),
    setOppType(state, { payload = null }) {
      state.oppType = payload;
    },
    unsetOpportunity() {
      return INITIAL_STATE;
    },
  },
});

export const {
  setIsLoading,
  setOpportunity,
  untrackOpportunity,
  unsetOpportunity,
  setOppType,
  setOpportunityAssignees,
} = summarySlice.actions;

export default summarySlice;
